<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'date',]"
      :typeslabel="{
        com_name: '회사명',
      }"
      :date-readonly="false"
    />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>평가종류</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    위험성결과 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 위험성결과</h5>
      <div class="writeGridContainer">
        <div>
          <div>대상기간(작성일)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }} ~ {{ form.inputB_2 }}</p>
          <div v-else class="time">
            <date-selector v-model="form.inputB_1" :readonly="board.readonly" @input="inputDate"/>
            <p class="px-2">~</p>
            <date-selector v-model="form.inputB_2" :readonly="board.readonly" @input="inputDate"/>
          </div>
        </div>
      </div>
    </div>
    <table>
      <colgroup>
        <col width="14%" />
        <col width="14%" />
        <col width="28%" />
        <col width="28%" />
        <col />
      </colgroup>
      <thead>
      <tr>
        <th colspan="2">위험성 수준(등급)</th>
        <th colspan="2">관리기준</th>
        <th>평가결과(건수)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in form.riskList">
        <td><span :style="{color:row.color}">{{ row.grade1 }}</span></td>
        <td><span :style="{color:row.color}">{{ row.grade2 }}</span></td>
        <td><span :style="{color:row.color}">{{ row.standard1 }}</span></td>
        <td style="text-align: start;"><span :style="{color:row.color}">{{ row.standard2 }}</span></td>
        <td><span :style="{color:row.color}">{{ row.count }}</span></td>
      </tr>
      </tbody>
    </table>


    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>담당</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>검토</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>승인</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import singlePageList from "@/views/boards/single-page/listIndex";

export default {
  components: {
    TimeSelector,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.riskList': {
      immediate: true,
      deep: true,
      handler(value) {
        value.forEach((item, index) => {
          if (index === 0) {
            this.form.sum_L = item.count
          } else if (index === 1) {
            this.form.sum_ML = item.count
          } else if (index === 2) {
            this.form.sum_M = item.count
          } else if (index === 3) {
            this.form.sum_H = item.count
          } else if (index === 4) {
            this.form.sum_HH = item.count
          }

        });
      },
    },
  },
  data() {
    return {
      boardList: [],
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputB_1: "",
        inputB_2: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },

        fileList: [],
        riskList: [
          { "id": 1, "grade1": "1~2(L)", "grade2": "낮음(L)", "standard1": "현재상태 유지", "standard2": "근로자에게 유해·위험성 정보제공 및 주기적인 안전보건 교육 실시", "color": "#3c3c3c", "count": 0},
          { "id": 2, "grade1": "3~4(ML)", "grade2": "보통(ML)", "standard1": "필요에 따라 개선", "standard2": "필요에 따라 개선활동 실시, 안전기준 및 작업절차(SOP) 준수", "color": "#3c3c3c", "count": 0},
          { "id": 3, "grade1": "6(M)", "grade2": "높음(M)", "standard1": "개선", "standard2": "안전보건 대책을 수립하고 개선 활동 실시", "color": "#C95611", "count": 0},
          { "id": 4, "grade1": "8~9(H)", "grade2": "매우높음(H)", "standard1": "즉시 개선", "standard2": "우선 위험감소 조치하고, 즉시 최단기간 內 개선 실행 긴급조치 실시", "color": "#E42728", "count": 0},
          { "id": 5, "grade1": "12~16(HH)", "grade2": "매우높음(H)", "standard1": "즉시 개선", "standard2": "우선 위험감소 조치하고, 즉시 최단기간 內 개선 실행 긴급조치 실시", "color": "#E42728", "count": 0},
        ],

        sum_L: 0,
        sum_ML: 0,
        sum_M: 0,
        sum_H: 0,
        sum_HH: 0,
      },
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    listFileData() {
      return singlePageList[`${this.boardId}_list`];
    },
  },
  methods: {
    inputDate() {
      if (this.form.inputB_1 && this.form.inputB_2) {
        this.loadRiskCount()
      }
    },

    /**
     * 위험성 평가 결과(건수)를 불러옵니다.
     * @returns {Promise<void>}
     */
    async loadRiskCount() {
      const payload = {
        boardIds: [592],
        projectId: this.projectId,
        beginAt: `${this.form.inputB_1}`,
        endAt: `${this.form.inputB_2}`,
        dateField: 'body.inputA_3',
        targetKeys: ['body.sum_L', 'body.sum_ML', 'body.sum_M', 'body.sum_H', 'body.sum_HH'],
      }

      const data = await this.$store.dispatch("summary/LOAD_DATE_RANGE_SUM", payload);
      if (data && data.counts) {
        this.form.riskList[0].count = data.counts["body.sum_L"] ? data.counts["body.sum_L"] : 0;
        this.form.riskList[1].count = data.counts["body.sum_ML"] ? data.counts["body.sum_ML"] : 0;
        this.form.riskList[2].count = data.counts["body.sum_M"] ? data.counts["body.sum_M"] : 0;
        this.form.riskList[3].count = data.counts["body.sum_H"] ? data.counts["body.sum_H"] : 0;
        this.form.riskList[4].count = data.counts["body.sum_HH"] ? data.counts["body.sum_HH"] : 0;
      }
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #000;
    padding: 15px 8px;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;

    &.link {
      color: #0085ff;
    }

    div {
      min-height: 18px;
    }
  }
}
</style>
